import { render, staticRenderFns } from "./TagEditView.vue?vue&type=template&id=9b25b0b2"
import script from "./TagEditView.vue?vue&type=script&lang=js"
export * from "./TagEditView.vue?vue&type=script&lang=js"
import style0 from "./TagEditView.vue?vue&type=style&index=0&id=9b25b0b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports